export const groupBy = (list, keyGetter) => {
  const map = new Map();
  /* eslint-disable @typescript-eslint/no-unsafe-call */
  list?.forEach(item => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  /* eslint-enable @typescript-eslint/no-unsafe-call */
  return map;
};
